import React from "react";
import clsx from "clsx";
import { makeStyles } from "@material-ui/core/styles";
import CssBaseline from "@material-ui/core/CssBaseline";
import Typography from "@material-ui/core/Typography";
import Container from "@material-ui/core/Container";
import Grid from "@material-ui/core/Grid";
import FullWidthTabs from "./tabPolicy"


const useStyles = makeStyles((theme) => ({
  root: {
    width: "auto",
    paddingLeft: 17,
    paddingRight: 0,
    "@media (min-width: 768px) and (max-width: 1024px)": {
      paddingLeft: 0,
    },
  },

  appBarSpacer: theme.mixins.toolbar,
  content: {
    flexGrow: 1,
    height: "100vh",
    overflowX: "hidden",
    backgroundColor: "#F6F6F6",
  },

  container: {
    paddingTop: theme.spacing(8),
    paddingBottom: theme.spacing(0),
    marginLeft: theme.spacing(10),
    paddingRight: theme.spacing(17),
    "@media (min-width: 768px) and (max-width: 1024px)": {
      marginLeft: "0px",
      paddingTop: "64px",
      paddingRight: "70px",
      paddingBottom: "0",
    },
  },
  link: {
    marginTop: theme.spacing(-6),
    marginBottom: theme.spacing(1),
    color: "#001441",
    fontWeight: "bold",
    "@media (min-width: 768px) and (max-width: 1024px)": {
      display: "none",
    },
  },
  input: {
    marginLeft: theme.spacing(1),
    flex: 1,
    "@media (min-width: 768px) and (max-width: 1024px)":{
      width: "88px",
    },
  },
  iconButton: {
    maxWidth: 30,
    maxHeight: 25,
  },
  


  grid: {
    display: "flex",
    justifyContent: "space-between",
    paddingBottom: "36px",
    marginTop: "-6px",
    "@media (min-width:768px) and (max-width:1024px)": {
      // display: "flex",
      //   justifyContent: "end",
    },
  },
  heading: {
    color: "#001441",
    fontWeight: "bold",
    "@media (min-width: 1025px)": {
      display: "none",
    },
  },
}));

export default function Terms() {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <CssBaseline />
      <main className={classes.content}>
        <div className={classes.appBarSpacer} />
        <Container maxWidth="" className={classes.container}>
          <Typography className={classes.link} variant="h6">
          Terms & Conditions And Privacy Policy
          </Typography>
          <Grid className={classes.grid}>
            <Typography className={classes.heading} variant="h6">
            Terms & Conditions And Privacy Policy
            </Typography>
           
          </Grid>
          <Grid item xs={12} sm={12} md={12}>
            <FullWidthTabs/>
          </Grid>
        </Container>
      </main>
    </div>
  );
}
